export default __webpack_public_path__ + "static/media/manac.4af949b5.svg";